import api from "./api.config";
const list = (params) => {
    
    return api
        .get(`/api/admin/payments`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const approval = (id, status, description) => {
    return api
        .post(`/api/admin/payments/approval/${id}`, {
            status,
            description
        })
        .then((response) => {
            return response.data;
        });
};


const PaymentsService = {
    list,
    approval
};

export default PaymentsService;